const editUserConfirmationDialogStyle = () => ({
	singleResultWrapper: {
		paddingBottom: 10,
		'& > p:first-of-type': {
			marginBottom: 4,
		},
	},
	changeUserResultsWrapper: {
		paddingBottom: 30,
		'& > div:last-of-type': {
			paddingBottom: 0,
		},
	},
});

export default editUserConfirmationDialogStyle;
